<template>
  <div>
    {{ msg }}
  </div>
</template>

<script>
  let CryptoJS = require("crypto-js");

  export default {
    name: 'Callback',
    data() {
      return {
        access_token: null,
        instance_url: null,
        id: null,
        issued_at: null,
        signature: null,
        msg: ''
      }
    },
    created() {
      let conf;
      if(process.env.NODE_ENV === 'production') {
        conf = require('../../config_prod.json');
      } else {
        conf = require('../../config_test.json');
      }
      let aParams = this.$route.hash.split('&');

      if(aParams.length) {

        // Here, we get all parameters provided by Salesforce
        let salesforceAccessToken = aParams[0].split('=');
        this.access_token = decodeURIComponent(salesforceAccessToken[1]);

        let salesforceInstanceUrl = aParams[1].split('=');
        this.instance_url = decodeURIComponent(salesforceInstanceUrl[1]);

        let id = aParams[2].split('=');
        this.id = decodeURIComponent(id[1]);

        let issuedAt = aParams[3].split('=');
        this.issued_at = decodeURIComponent(issuedAt[1]);

        let signature = aParams[4].split('=');
        this.signature = decodeURIComponent(signature[1]);

        // Concat of id and issuedAt + Hmac Sha256 + Base 64
        let concat = this.id + this.issued_at;

        let hashConcat = CryptoJS.HmacSHA256(concat, conf.keyHash);
        let hashConcat64 = CryptoJS.enc.Base64.stringify(hashConcat);

        // We check if the signature is correct, based on our own hashing
        if(hashConcat64 === this.signature) {
          const data = {
            salesforceAccessToken: this.access_token,
            salesforceInstanceUrl: this.instance_url
          }
          this.$store.dispatch('salesforceLogin', data, {})
            .then(() => {
              this.$router.push('/filters');
            })
            .catch(error => {
              // Else, we show him our Error page
              console.log(error);
              this.msg = "Erreur lors de la récupération de l'utilisateur";
            });
        } else {
          // Signature is not correct
          this.msg = "L'authentification a échouée";
        }
      }
    }
  }
</script>
